// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//
// Targets the hepconmaui-debug Firebase project (staging). Was
// previously pointed at the legacy hepcon-9da38 project; flipped
// during the WebAdmin migration to the new project family.

export const environment = {
  production: false,
  // When true, the app connects Firestore/Auth/Functions/Storage to the local
  // Firebase emulators instead of the live project. Only the e2e build sets
  // this (see environment.e2e.ts + the `e2e` configuration in angular.json);
  // normal dev/staging/prod builds leave it false and hit the real backend.
  useEmulators: false,
  defaultauth: 'firebase', //defaultauth: 'fakebackend',
  firebaseConfig : {
    apiKey: "AIzaSyAvjiUroFMoWftotJQiHxMBC8irTUyZRPg",
    authDomain: "hepconmaui-debug.firebaseapp.com",
    databaseURL: "https://hepconmaui-debug.firebaseio.com",
    projectId: "hepconmaui-debug",
    storageBucket: "hepconmaui-debug.firebasestorage.app",
    messagingSenderId: "63524197692",
    // appId + measurementId come from the Firebase console:
    //   Project settings → Your apps → Web app → Config
    // Register a Web app on hepconmaui-debug if one doesn't exist
    // yet (no Hosting checkbox needed during registration).
    appId: "1:63524197692:web:504a2f9574b25ccce87a39",
    measurementId: "G-EWX728S5F3"
  },
  // ORCID / LinkedIn sign-in (redirect OIDC via the exchangeOidcCode CF). The
  // web REUSES the mobile bounce redirect already registered with each provider
  // (https://<authDomain>/auth/<provider>/callback) — no provider-dashboard
  // change — and the bounce page forwards web sign-ins to this WebAdmin. Client
  // secrets stay server-side in the CF; only the public client_id is needed here.
  oidc: {
    redirectHost: 'hepconmaui-debug.firebaseapp.com',
    google: { clientId: '63524197692-pbat7c2qe8uiqth2d214ib3tj1ekc719.apps.googleusercontent.com', authorizeUrl: 'https://accounts.google.com/o/oauth2/v2/auth', scopes: 'openid email profile' },
    orcid: { clientId: 'APP-O4VV4GHDLF7AA46D', authorizeUrl: 'https://orcid.org/oauth/authorize', scopes: 'openid' },
    linkedin: { clientId: '77gn7lsrbj8cry', authorizeUrl: 'https://www.linkedin.com/oauth/v2/authorization', scopes: 'openid profile email' },
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
